import { createReducer, on } from '@ngrx/store';
import { coordinateSystemsAdapter, ICoordinateSystemsState, initialState } from './coordinate-systems.state';
import {
  coordinateSystemsFailure,
  loadCoordinateSystems,
  loadCoordinateSystemsSuccess,
} from './coordinate-systems.actions';

export const coordinateSystemsReducer = createReducer(
  initialState,

  on(
    loadCoordinateSystems,
    (state): ICoordinateSystemsState => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
    })
  ),

  on(
    loadCoordinateSystemsSuccess,
    (state, { coordinateSystems }): ICoordinateSystemsState =>
      coordinateSystemsAdapter.setAll(coordinateSystems, {
        ...state,
        loading: false,
        loaded: true,
      })
  ),

  on(
    coordinateSystemsFailure,
    (state, { error }): ICoordinateSystemsState => ({
      ...state,
      loading: false,
      loaded: false,
      error,
    })
  )
);
